export default function(fields) {
  return {
    currentPassword: fields.currentPassword,
    newPassword: fields.newPassword
  }
}
